module.exports = __webpack_public_path__ + "4ff37009f2286f67399686445ee6d482.pdf";